import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {Field} from '../../interfaces/Field';
import {MD_DIALOG_DATA, MdDialogRef, MdSelectChange} from '@angular/material';
import {EFieldType} from '../../enums/e-field-type.enum';
import {FormControl, FormGroup} from '@angular/forms';
import {DropDownFieldOption} from '../../interfaces/DropDownFieldOption';
import {FieldEditorDialogParams} from './field-editor-dialog-params';
import {FieldOptionService} from '../../services/field-option/field-option.service';
import {FieldFormControlService} from '../../services/field/field-form-control-service';
import {CalculationEditorComponent} from '../calculation-editor/calculation-editor.component';
import {ECalculationStatus} from '../calculation-editor/e-calculation-status';
import {strings} from '../../strings';
import {CurrentUserService} from '../../../user/services/current-user/current-user.service';
import {User} from '../../../user/interfaces/User';

@Component({
  selector: 'app-field-editor-dialog',
  templateUrl: './field-editor-dialog.component.html',
  styleUrls: ['./field-editor-dialog.component.scss']
})
export class FieldEditorDialogComponent implements OnInit  {
  currentUser: User;
  userCanAddSignature = false;
  public field: Field;
  public dialogTitle: string;
  public fieldForm: FormGroup;
  public EFieldType = EFieldType;
  public signatureWarning = strings.signatureWarning;
  @ViewChild(CalculationEditorComponent)
  public calculationEditor: CalculationEditorComponent;
  public calculationStatus = ECalculationStatus.NOT_RUN;

  public fieldTypeOptions = [
    {name: 'Checkbox', value: EFieldType.CHECKBOX},
    {name: 'Date', value: EFieldType.DATE},
    {name: 'Decimal', value: EFieldType.DECIMAL},
    {name: 'Dropdown', value: EFieldType.DROPDOWN},
    {name: 'Integer', value: EFieldType.INTEGER},
    {name: 'Text', value: EFieldType.TEXT},
    {name: 'Timestamp', value: EFieldType.TIMESTAMP},
    {name: 'Yes/No', value: EFieldType.YES_NO},
    {name: 'Calculation', value: EFieldType.CALCULATION}
  ];


  public signatureOptions = [
    {name: 'Flight Number', value: 'flight_number'},
    {name: 'Aircraft Type', value: 'aircraft_type'},
    {name: 'Arrival Time', value: 'arrival_time'},
    {name: 'Airline', value: 'airline'},
    {name: 'Airport', value: 'airport'},
    {name: 'Date', value: 'date'},
    {name: 'Operation', value: 'operation'},
    {name: 'Feedback', value: 'feedback'},
    {name: 'Total Complaints', value: 'total_complaints'},
    {name: 'Total Compliments', value: 'total_compliments'},
    {name: 'Departing Time', value: 'departing_time'},
    {name: 'Departing Flight', value: 'departing_flight_number'}
  ];

  fieldOptions: DropDownFieldOption[] = [];

  /**
   *
   * @param {MdDialogRef<FieldEditorDialogComponent>} dialogRef
   * @param data
   * @param {FieldOptionService} fieldOptionService
   * @param fieldFormControlService
   * @param currentUserService
   */
  constructor(public dialogRef: MdDialogRef<FieldEditorDialogComponent>,
              @Inject(MD_DIALOG_DATA) public data:  FieldEditorDialogParams,
              private fieldOptionService: FieldOptionService,
              private fieldFormControlService: FieldFormControlService,
              private currentUserService: CurrentUserService
  ) { }


  onTypeChanged(change: MdSelectChange) {
    this.field.type = change.value;
  }


  ngOnInit(): void {
    this.initializeFieldModel();
    this.createForm();
    this.currentUserService.getCurrentUser().subscribe( (res) => {
      for (let i = 0; i < res.permissions.length; i++) {
        if (res.permissions[i].name === 'add-signature')
          this.userCanAddSignature = true;
      }
    });
  }

  initializeFieldModel() {
    if (this.data.field) {
      this.field = this.data.field;
      this.dialogTitle = 'Edit Field';
    } else {
      this.field = {
        type: null,
        name: '',
        visible: true,
        readonly: false,
        typeText: '',
        signature: null,
        required: true
      };
      this.dialogTitle = 'Add Field';
    }
  }

  /**
   * Scaffold out the fieldForm
   */
  createForm() {
    this.fieldForm = this.fieldFormControlService.toFormGroup(this.field);
    if (this.field.type === EFieldType.DROPDOWN && this.field.datasource === 'Manual') {
        this.fieldOptionService.getList(this.field.id)
          .then((response: DropDownFieldOption[]) => this.fieldOptions = response);
    }
  }

   canSubmit() {
      return this.fieldForm.valid && this.calculationStatus === ECalculationStatus.SUCCESS;
  }
  /**
   * Closes the dialog and returns the form value
   */
  onSubmit() {

    // Because the fields are conditional we can only really add them when the user submits the form
    if (this.field.type === EFieldType.DROPDOWN) {
      this.fieldForm.addControl('datasource', new FormControl(this.field.datasource));
      if (this.field.datasource === 'Manual') {
        let holder = '';
        // Here we put the code for saving each of the fields
        for (const element of this.fieldOptions) {
          holder = holder.concat(element.name);
          holder = holder.concat('%%'); // This value will be used to separate the actual field options
        }
        this.fieldForm.addControl('fieldoptions', new FormControl(holder));
      }
    } else if (this.calculationEditor != null) {
      this.calculationEditor.handleSubmit(this.fieldForm);
    }
    // We merge the changes with the data object and then pass them to the process
    // that opened the dialog, closing the dialog at the same time
    const merged = {...this.field, ...this.fieldForm.value};
    this.dialogRef.close(merged);
  }


  onDataSourceChanged(datasource) {
    this.field.datasource = datasource;
  }

  calculationStatusChanged(status: ECalculationStatus) {
    this.calculationStatus = status;
  }


}






// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/form-builder/components/field-editor-dialog/field-editor-dialog.component.ts